<template>
<span class="d-flex">
	<menu-icon
		name="station_manage"
		color="currentColor"
		edge-size="18"
		class="me-2"
	/>
	Локально змінено
</span>

<p
	v-for="prop in parameters"
	:key="prop"
	class="paragraph-indent"
>
	{{ capitalizeFirstLetter(paremeterTitle(prop)) }}:
	{{ paremeterValue(prop, $props[prop].old) }}
	&nbsp;
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		fill="currentColor"
		class="bi bi-arrow-right"
		viewBox="0 0 16 16"
	>
		<path
			fill-rule="evenodd"
			d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
		/>
	</svg>
	&nbsp;
	{{ paremeterValue(prop, $props[prop].new) }}
</p>
</template>



<script>
import MenuIcon from '@/components/Icons/MenuIcon.vue'
import { PowerUnit } from '@/models/powerUnit.js'
import { STAB_PARMS } from '@/app.conf.js'
import { capitalizeFirstLetter } from '@/helpers.js'


export default {
	components: {
		MenuIcon,
	},

	props: {
		// If parameter is change, then will bee Object { old: value, new: value }
		[PowerUnit.metricKeys.stationStabilizationMode]: {
			type: Object,
			required: false,
			default: undefined,
		},
		
		// If parameter is change, then will bee Object { old: value, new: value }
		[PowerUnit.metricKeys.stationStabilizationCurent]: {
			type: Object,
			required: false,
			default: undefined,
		},

		// If parameter is change, then will bee Object { old: value, new: value }
		[PowerUnit.metricKeys.stationStabilizationVoltage]: {
			type: Object,
			required: false,
			default: undefined,
		},

		// If parameter is change, then will bee Object { old: value, new: value }
		[PowerUnit.metricKeys.stationStabilizationPotential]: {
			type: Object,
			required: false,
			default: undefined,
		},
	},

	setup() {
		return {
			PowerUnit,
			capitalizeFirstLetter,
		}
	},

	methods: {
		paremeterTitle(key) {
			switch(key) {
				case PowerUnit.metricKeys.stationStabilizationMode:
					return 'Параметр стабілізації'
				case PowerUnit.metricKeys.stationStabilizationCurent:
					return STAB_PARMS.I.name
				case PowerUnit.metricKeys.stationStabilizationVoltage:
					return STAB_PARMS.U.name
				case PowerUnit.metricKeys.stationStabilizationPotential:
					return STAB_PARMS.E.name
				default:
					return '-'
			}
		},

		paremeterValue(key, value) {
			switch(key) {
				case PowerUnit.metricKeys.stationStabilizationMode:
					return PowerUnit.stabilizationModeText(value)
				case PowerUnit.metricKeys.stationStabilizationCurent:
				case PowerUnit.metricKeys.stationStabilizationVoltage:
				case PowerUnit.metricKeys.stationStabilizationPotential:
					return Number(value).toFixed(2)
				default:
					return '-'
			}
		},
	},

	computed: {
		parameters() {
			return Object.keys(this.$props).filter((el) => this.$props[el] !== undefined)
		},
	},
}
</script>